// import React, { useState } from "react";
// import clsx from "clsx";

// interface ImageLoadedProps {
//   src: string;
//   alt?: string;
//   className?: string; // for customizing image styles
//   wrapperClassName?: string; // for customizing wrapper div
//   circle?: boolean; // if true → round image
// }

// const LazyImage: React.FC<ImageLoadedProps> = ({
//   src,
//   alt = "image",
//   className,
//   wrapperClassName,
//   circle = false,
// }) => {
//   const [loaded, setLoaded] = useState(false);

//   return (
//     <div
//       className={clsx(
//         "relative flex items-center justify-center overflow-hidden bg-gray-100 h-full w-full ",
//         circle ? "rounded-full" : "",
//         wrapperClassName
//       )}
//     >
//       {/* Skeleton while loading */}
//       {!loaded && (
//         <div
//           className={clsx(
//             "absolute inset-0 bg-gray-200 animate-pulse",
//             circle ? "rounded-full" : ""
//           )}
//         />
//       )}

//       <img
//         src={src}
//         alt={alt}
//         className={clsx(
//           "w-full h-full object-cover transition-opacity duration-300",
//           circle ? "rounded-full" : "",
//           loaded ? "opacity-100" : "opacity-0",
//           className
//         )}
//         onLoad={() => setLoaded(true)}
//         loading="lazy"
//         decoding="async"
//       />
//     </div>
//   );
// };

// export default LazyImage;


import clsx from "clsx"
import React from "react"
import { useState, useEffect, useRef } from "react"


interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  wrapperClassName?: string
  circle?: boolean
}

export default function LazyImage({
  src,
  alt = "image",
  className,
  wrapperClassName,
  circle = false,
  ...props
}: LazyImageProps) {
  const [loaded, setLoaded] = useState(false)
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    // Check if image is already loaded (e.g. from cache)
    if (imgRef.current?.complete) {
      setLoaded(true)
    }
  }, [])

  return (
    <div
      className={clsx(
        "relative flex h-full w-full items-center justify-center overflow-hidden bg-muted",
        circle && "rounded-full",
        wrapperClassName,
      )}
    >
      {/* Skeleton/Placeholder */}
      <div
        className={clsx(
          "absolute inset-0 animate-pulse bg-muted-foreground/10",
          circle && "rounded-full",
          loaded ? "hidden" : "block",
        )}
      />
      <img
        ref={imgRef}
        src={src || "/placeholder.svg"}
        alt={alt}
        className={clsx(
          "h-full w-full object-cover transition-opacity duration-500",
          circle && "rounded-full",
          loaded ? "opacity-100" : "opacity-0",
          className,
        )}
        onLoad={() => setLoaded(true)}
        loading="lazy"
        decoding="async"
        {...props}
      />
    </div>
  )
}
